<template>
	<div class="pa-2">
		<v-row
			dense
			class="mb-3">
			<v-col cols="2">
				<v-text-field
					dense
					outlined
					:label="$T('inputs.name')"
					hide-details></v-text-field>
			</v-col>
	
			<v-col cols="10">
				<v-row class="" align="center">
					<v-col>
						<v-autocomplete 
							:items="[]"
							dense
							row
							hide-details
							label="المنصب الحالي"
							outlined
						/>
					</v-col>
					<v-col>
						<v-radio-group
							label="نوع التقييم"
							dense
							row
							hide-details
							class="mt-0">
							<v-radio
								label="سنوي"
								:value="0"></v-radio>
							<v-radio
								label="نص سنوي"
								:value="1"></v-radio>
						</v-radio-group>
					</v-col>
					فترة محدد :
					<v-col cols="2">
						<bee-date-picker
							input-label="من"
							:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
							:months-over-max="5"
							menu-picker
							calendar
							no-title
							hide-details></bee-date-picker>
					</v-col>
					<v-col cols="2">
						<bee-date-picker
						input-label="إلى"
						:input-props="{ outlined: true, dense: true, prependInnerIcon: '$calendar' }"
						:months-over-max="5"
						menu-picker
						calendar
						no-title
						hide-details></bee-date-picker>

					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<!-- <v-card class="pa-6 px-15"> -->
		<h2 class="text-h6 mb-2 text-start">المهارات العامة</h2>
		<bee-handy-table
			:headers="headers"
			:items="items"
			dense
			zebra
			height="auto"
			:items-per-page="-1"
			fixed-header
			hide-default-footer
		>
			<template v-slot:item.value="{ item }">
				<v-radio-group
					v-model="item.rolePermissions"
					row
					hide-details
					class="mt-0"
					:disabled="Boolean($route.query.preview)"
					small
				>
					<v-radio
						label="5%"
						:value="1"
					></v-radio>
					<v-radio
						label="25%"
						:value="2"
					></v-radio>
					<v-radio
						label="50%"
						:value="3"
					></v-radio>
					<v-radio
						label="75%"
						:value="4"
					></v-radio>
					<v-radio
						label="100%"
						:value="5"
					></v-radio>
				</v-radio-group>
			</template>

			<template v-slot:item.note="{}">
				<v-text-field hide-details />
			</template>
		</bee-handy-table>
		
		<!-- <v-divider class="my-5"></v-divider> -->

		<v-row dense>
			<v-col cols="6">
				<v-textarea
					class="mt-3"
					label="التعليقات"
					rows="3"
					outlined
					dense
					hide-details
					auto-grow></v-textarea>
			</v-col>

			<v-col>
				<v-textarea
					class="mt-3"
					label="الإنجازات التي تم تحقيقها منذ اخر تقييم"
					rows="3"
					outlined
					dense
					hide-details
					auto-grow></v-textarea>
			</v-col>
			<v-col cols="6">
				<v-textarea
					label="نقاط القوة"
					rows="7"
					outlined
					dense
					hide-details
					auto-grow></v-textarea>
			</v-col>
			<v-col cols="6">
				<v-textarea
					label="نقاط يجب تطويرها وتحسينها"
					rows="7"
					outlined
					dense
					hide-details
					auto-grow></v-textarea>
			</v-col>
			<v-col cols="12">
				<v-textarea
					class="mt-3"
					label="تعليقات الموظف"
					rows="3"
					outlined
					dense
					hide-details
					auto-grow></v-textarea>
			</v-col>
		</v-row>
		<!-- </v-card> -->
	</div>
</template>

<script>
export default {
	name: 'EmployeePerformance',

	data() {
		return {
			headers: [
				{
					text: '',
					name: 'name',
					value: 'name'
				},
				{
					text: '',
					name: 'value',
					value: 'value'
				},
				{
					text: 'الملاحظة',
					name: 'note',
					value: 'note'		
				}
			],
			items: [
				{
					name:  'السرعة بإنجاز المهام المكلف بها',
					value: 0,
					note: ''
				},
				{
					name: 'جودة الاعمال التي يقوم بتنفيذها',
					value: 0,
					note: ''
				},
				{
					name: 'الاعمال التي يقوم بها ) العدد + السرعة(',
					value: 0,
					note: ''
				},
				{
					name: 'القدرة على أداء العمل دون توجيه وتعليمات مفصلة',
					value: 0,
					note: ''
				},
				{
					name: 'التعاون مع الزملاء في تنفيذ الاعمال الاستثنائية والتفاني في العمل',
					value: 0,
					note: ''
				},
				{
					name: 'المحافظة على أدوات العمل',
					value: 0,
					note: ''
				},
				{
					name: 'التواجد في المكان المخصص للعمل',
					value: 0,
					note: ''
				},
				{
					name: 'الالتزام بالقوانين والانظمة والتعليمات',
					value: 0,
					note: ''
				},
				{
					name: 'تقبل توجيهات المسؤول المباشر',
					value: 0,
					note: ''
				},
				{
					name: 'تنفيذ ما يكلف به من مهام دون تذمر أو شكوى',
					value: 0,
					note: ''
				},
				{
					name: 'الالتزام بتعليمات الدوام',
					value: 0,
					note: ''
				},
				{
					name: 'المحافظة على المظهر العام وترتيب الملابس والنظافة',
					value: 0,
					note: ''
				},
				{
					name: 'تحمل المسؤولية في حال ارتكاب الاخطاء',
					value: 0,
					note: ''
				},
				{
					name: 'التعامل باحترام ومهنية مع الرؤساء وزملاء العمل',
					value: 0,
					note: ''
				},
				{
					name: 'تنظيم العمل تحت الضغط',
					value: 0,
					note: ''
				}

			]
		};
	},
};
</script>

<style lang="scss">
.interview .v-input--radio-group__input {
	justify-content: space-between;
}
</style>
